<template>
  <v-row class="my-6" style="justify-content: space-between">
    <v-col cols="12" md="5">
      <v-card elevation="0">
        <div id="app">


          <v-col class="shrink my-4" style="min-width: 220px">
            <h5 class="grey--text pt-3">Fonte (família)</h5>
              <v-select :items="fontFamilies" item-value="value" item-text="text" v-model="formColor.fontFamily"> </v-select>
             
            <div v-if="formColor.customHeader.backgroundType == 'gradient'">
              <h5 class="grey--text">Direção do gradiente</h5>

              <v-btn-toggle v-model="deg" class="my-3">
                <v-btn>
                  <v-icon>mdi-gradient-horizontal</v-icon>
                </v-btn>
                <v-btn>
                  <v-icon>mdi-gradient-vertical</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>


            <h5 class="grey--text pt-3">Efeito do header</h5>
            <v-radio-group v-model="formColor.customHeader.backgroundType">
              <v-radio value="gradient"
                :label="$t('mainStore.personalize.colorSection.customHeader.backgroundType.gradient')"></v-radio>
              <v-radio value="solid"
                :label="$t('mainStore.personalize.colorSection.customHeader.backgroundType.solid')"></v-radio>
            </v-radio-group>
            <div v-if="formColor.customHeader.backgroundType == 'gradient'">
              <h5 class="grey--text">Direção do gradiente</h5>

              <v-btn-toggle v-model="deg" class="my-3">
                <v-btn>
                  <v-icon>mdi-gradient-horizontal</v-icon>
                </v-btn>
                <v-btn>
                  <v-icon>mdi-gradient-vertical</v-icon>
                </v-btn>
              </v-btn-toggle>
            </div>

           
            <h5 class="grey--text pt-3">{{ $t('mainStore.personalize.colorSection.customHeader.colorStart') }}</h5>
            <v-text-field v-model="formColor.customHeader.colorStart" hide-details class="ma-0 pa-0">
              <template v-slot:append>
                <v-menu v-model="menu.headerColorStart" top nudge-bottom="105" nudge-left="16"
                  :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <div :style="switchStyleHeaderColorStart" v-on="on" />
                  </template>
                  <v-card elevation="0">
                    <v-card-text class="pa-0">
                      <v-color-picker v-model="formColor.customHeader.colorStart" flat />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </template>
            </v-text-field>
           
           
            <template  v-if="formColor.customHeader.backgroundType == 'gradient'">

              <h5 class="grey--text pt-3">{{ $t('mainStore.personalize.colorSection.customHeader.colorEnd') }}</h5>
              <v-text-field v-model="formColor.customHeader.colorEnd" hide-details class="ma-0 pa-0">
                <template v-slot:append>
                  <v-menu v-model="menu.headerColorEnd" top nudge-bottom="105" nudge-left="16"
                    :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <div :style="switchStyleHeaderColorEnd" v-on="on" />
                    </template>
                    <v-card elevation="0">
                      <v-card-text class="pa-0">
                        <v-color-picker v-model="formColor.customHeader.colorEnd" flat />
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
              </v-text-field>
            </template>
            <h5 class="grey--text pt-3">Tema do header</h5>
<v-radio-group v-model="formColor.customHeader.theme">
      <v-radio
       
        :label="`Escuro`"
        :value="'dark'"
      ></v-radio>
      <v-radio
       
        :label="`Claro`"
        :value="'light'"
      ></v-radio>
    </v-radio-group>

            <h5 class="grey--text pt-3">Logo</h5>

            <v-switch hide-details v-model="formColor.customHeader.paintLogo" :label="formColor.customHeader.paintLogo ? 'Pintar logo de branco' : 'Manter logo original'">

            </v-switch>

          </v-col>



          <v-col class="shrink my-4" style="min-width: 220px">
            <h5 class="grey--text">{{ $t('mainStore.personalize.colorSection.headerColor') }}</h5>
            <v-text-field v-model="formColor.headerColor" hide-details class="ma-0 pa-0">
              <template v-slot:append>
                <v-menu v-model="menu.header" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <div :style="switchStyleHeader" v-on="on" />
                  </template>
                  <v-card elevation="0">
                    <v-card-text class="pa-0">
                      <v-color-picker v-model="formColor.headerColor" flat />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </template>
            </v-text-field>
          </v-col>



          <v-switch v-model="formColor.headerTheme" :label="formColor.headerTheme
              ? $t('mainStore.personalize.colorSection.headerDark')
              : $t('mainStore.personalize.colorSection.headerLight')
            "></v-switch>
          <v-col class="shrink my-4" style="min-width: 220px">
            <h5 class="grey--text">{{ $t('mainStore.personalize.colorSection.headerSpacement') }}</h5>
            <v-text-field v-model="formColor.headerPy" hide-details class="ma-0 pa-0">
              <template v-slot:append>PX</template>
            </v-text-field>
          </v-col>
          <v-col class="shrink my-4" style="min-width: 220px">
            <h5 class="grey--text">{{ $t('mainStore.personalize.colorSection.background') }}</h5>
            <FileUpload :unique="true" :sample="true" :snap="[formColor.homeBackground]"
              :target="`whitelabel/backgrounds/${objectId}`" :error="null"
              @set-upload="formColor.homeBackground = $event">
            </FileUpload>

            <v-text-field v-model="formColor.homeBackground" hide-details class="ma-0 pa-0">
            </v-text-field>
          </v-col>
          <v-col class="shrink my-4" style="min-width: 220px">

            <h5 class="grey--text">{{ $t('mainStore.personalize.colorSection.primaryColor') }}</h5>
            <v-text-field v-model="formColor.primaryColor" hide-details class="ma-0 pa-0">
              <template v-slot:append>
                <v-menu v-model="menu.primary" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <div :style="swatchStylePrimary" v-on="on" />
                  </template>
                  <v-card elevation="0">
                    <v-card-text class="pa-0">
                      <v-color-picker v-model="formColor.primaryColor" flat />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </template>
            </v-text-field>
          </v-col>
          <v-switch v-model="formColor.primaryThemeDark" :label="formColor.primaryThemeDark
              ? $t('mainStore.personalize.colorSection.colorBtnWhite')
              : $t('mainStore.personalize.colorSection.colorBtnBlack')
            "></v-switch>

          <v-col class="shrink my-4" style="min-width: 220px">
            <h5 class="grey--text">{{ $t('mainStore.personalize.colorSection.secundaryColor') }}</h5>
            <v-text-field v-model="formColor.secondaryColor" hide-details class="ma-0 pa-0">
              <template v-slot:append>
                <v-menu v-model="menu.secondary" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <div :style="swatchStyleSecondary" v-on="on" />
                  </template>
                  <v-card elevation="0">
                    <v-card-text class="pa-0">
                      <v-color-picker v-model="formColor.secondaryColor" flat />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </template>
            </v-text-field>
          </v-col>

          <v-switch v-model="formColor.primaryIconDark" :label="formColor.primaryIconDark
              ? $t('mainStore.personalize.colorSection.colorIconWhite')
              : $t('mainStore.personalize.colorSection.colorIconBlack')

            "></v-switch>

          <v-col class="shrink my-4" style="min-width: 220px">
            <h5 class="grey--text">{{ $t('mainStore.personalize.colorSection.titleColor') }}</h5>
            <v-text-field v-model="formColor.titleColor" hide-details class="ma-0 pa-0">
              <template v-slot:append>
                <v-menu v-model="menu.title" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <div :style="swatchStyleTitle" v-on="on" />
                  </template>
                  <v-card elevation="0">
                    <v-card-text class="pa-0">
                      <v-color-picker v-model="formColor.titleColor" flat />
                    </v-card-text>
                  </v-card>
                </v-menu>
              </template>
            </v-text-field>
          </v-col>
        </div>
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card elevation="0" outlined class="p"
        :style="formColor.homeBackground ? `background: url(${formColor.homeBackground}); background-size: cover` : '#fff'">
        <v-card class="d-flex align-center px-3" tile :style="`background: ${headerColor}`" width="100%"
          :dark="formColor.headerTheme"
          >
          <div  class="d-flex align-center" :style="` width: 100%; margin-top: ${formColor.headerPy}px; margin-bottom: ${formColor.headerPy}px`">
            <v-img
              :style="headerLogo"
              :src="logo" position="left center" height="40" width="100" class="justify-start" contain></v-img>
            <v-spacer></v-spacer>
            <v-btn text :color="formColor.headerColor">Home</v-btn>
            <v-btn text :color="formColor.headerColor">####</v-btn>
            <v-icon :color="formColor.headerColor">mdi-cart</v-icon>
          </div>
        </v-card>
        <div class="d-flex justify-space-between align-center">
          <v-card-title class="font-weight-bold" :style="`color:${formColor.titleColor}`">
            {{ $t('mainStore.personalize.colorSection.expTitle') }}
          </v-card-title>
          <v-btn class="mx-4" :dark="formColor.primaryThemeDark" :color="formColor.primaryColor" 
            elevation="0">{{ $t('mainStore.personalize.colorSection.expBtn') }}</v-btn>
        </div>
        <v-divider class="my-2"></v-divider>

        <v-card-title class="font-weight-bold" :style="`color:${formColor.titleColor}`">
          {{ $t('mainStore.personalize.colorSection.expTitle2') }}
        </v-card-title>
        <div class="d-flex mb-10 justify-space-between mx-5">
          <v-card elevation="0" outlined max-width="150"><v-avatar tile size="150" color="grey lighten-3"></v-avatar>
            <div class="pa-2">
              <v-btn elevation="0" :color="formColor.primaryColor" :dark="formColor.primaryThemeDark"
                block>{{ $t('mainStore.personalize.colorSection.expBtn') }}</v-btn>
            </div>
          </v-card>
          <v-card elevation="0" outlined max-width="150"><v-avatar tile size="150" color="grey lighten-3"></v-avatar>

            <div class="pa-2">
              <v-btn elevation="0" :color="formColor.primaryColor" :dark="formColor.primaryThemeDark"
                block>{{ $t('mainStore.personalize.colorSection.expBtn') }}</v-btn>
            </div>
          </v-card>
          <v-card elevation="0" outlined max-width="150"><v-avatar tile size="150" color="grey lighten-3"></v-avatar>

            <v-checkbox :color="formColor.primaryColor" elevation="0"
              class="ma-1">{{ $t('mainStore.personalize.colorSection.expBtn') }}</v-checkbox></v-card>
        </div>
        <div class="d-flex justify-space-around pb-5">
          <v-avatar :color="formColor.secondaryColor" size="46"><v-icon
              :dark="formColor.primaryIconDark">mdi-star-outline</v-icon></v-avatar>
          <v-avatar :color="formColor.secondaryColor" size="46"><v-icon
              :dark="formColor.primaryIconDark">mdi-alarm</v-icon></v-avatar>
          <v-avatar :color="formColor.secondaryColor" size="46"><v-icon
              :dark="formColor.primaryIconDark">mdi-calendar-star-outline</v-icon></v-avatar>
        </div>

        <div class="d-flex justify-space-around pb-5">
          <v-card color="#EEEEEE" min-width="100" min-height="75" elevation="0" outlined></v-card>
          <v-card color="#EEEEEE" min-width="100" min-height="75" elevation="0" outlined></v-card>
          <v-card color="#EEEEEE" min-width="100" min-height="75" elevation="0" outlined></v-card>
          <v-card color="#EEEEEE" min-width="100" min-height="75" elevation="0" outlined></v-card>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from "vuex";
import FileUpload from '@/interface/FileUpload.vue'

export default {
  name: "ColorsSection",
  components: {
    FileUpload
  },
  data: () => ({
    fontFamilies: [{value: 'Roboto, sans-serif!important', text: 'Roboto (padrão)'}, {value: "'Proxima Nova', sans-serif !important", text: 'Proxima Nova'}],
    deg: 0,
    theme: false,
    objectId: null,
    formColor: {
      fontFamily: 'Roboto, sans-serif!important',
      headerColor: '#FFFFFF',
      headerTheme: false,
      homeBackground: '',
      headerPy: 0,
      primaryColor: "#EEEEEE",
      secondaryColor: "#EEEEEE",
      titleColor: "#EEEEEE",
      primaryThemeDark: false,
      primaryIconDark: false,
      customHeader: {
        backgroundType: 'gradient',
        deg: 90,
        colorStart: '#730f76',
        colorEnd: '#002b81',
        paintLogo: true,
        dark: false,
        theme: 'dark'
      }
    },
    menu: {
      header: false,
      title: false,
      primary: false,
      secondary: false,
      headerColorStart: false,
      headerColorEnd: false
    },


  }),
  props: {
    snap: Object,
    logo: String
  },
  mounted() {
    this.load()
  },
  computed: {
    ...mapState("groupStores", [
      "selectedStore",
    ]),
    switchStyleHeaderColorStart() {
      return {
        backgroundColor: this.formColor.customHeader.colorStart,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: this.menu.headerColorStart ? "50%" : "4px",
        border: '1px solid #000',
        transition: "border-radius 200ms ease-in-out",
      };
    },

    switchStyleHeaderColorEnd() {
      return {
        backgroundColor: this.formColor.customHeader.colorEnd,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: this.menu.headerColorEnd ? "50%" : "4px",
        border: '1px solid #000',
        transition: "border-radius 200ms ease-in-out",
      };
    },


    swatchStylePrimary() {

      return {
        backgroundColor: this.formColor.primaryColor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: this.menu.primary ? "50%" : "4px",
        border: '1px solid #000',
        transition: "border-radius 200ms ease-in-out",
      };
    },
    switchStyleHeader() {
      return {
        backgroundColor: this.formColor.headerColor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: this.menu.header ? "50%" : "4px",
        border: '1px solid #000',
        transition: "border-radius 200ms ease-in-out",
      };
    },
    swatchStyleSecondary() {

      return {
        backgroundColor: this.formColor.secondaryColor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: this.menu.secondary ? "50%" : "4px",
        border: '1px solid #000',
        transition: "border-radius 200ms ease-in-out",
      };
    },
    swatchStyleTitle() {

      return {
        backgroundColor: this.formColor.titleColor,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: this.menu.title ? "50%" : "4px",
        border: '1px solid #000',
        transition: "border-radius 200ms ease-in-out",
      };
    },

    headerColor() {
      const fc = this.formColor
      let background = fc.headerColor ? fc.headerColor : 'white'
      if (fc.hasOwnProperty('customHeader')) {
        const c = fc.customHeader;
        if (c.backgroundType == 'gradient') {
          background = `linear-gradient(${c.deg}deg, ${c.colorStart}, ${c.colorEnd})`
        }
        else {
          background = c.colorStart
        }
      }
      return background
    },
    headerLogo() {
      const fc = this.formColor

      let res = fc.headerTheme ? `filter: invert(1) hue-rotate(180deg); background-color: #ffffff ` : 'background-color: rgba(255,255,255,0)'
      if (fc.hasOwnProperty('customHeader')) {
        const c = fc.customHeader;
        if (c.paintLogo == true) {
          res = `filter: grayscale(1) brightness(${c.theme == 'dark' ? '0' : '100'})`
        }
      }
      return res
    },
    headerColorText() {
      const fc = this.formColor
      return fc.customHeader.theme == 'dark' ? 'black' : 'white'
    },
  },

  watch: {
    formColor: {
      deep: true,
      handler() {
        this.sendColors()
      }
    },
    'selectedStore': {
      deep: true,
      haldler() {
        this.load()
      }
    },
    deg(v){
      console.log('V', v)
      this.formColor.customHeader.deg = (v == 0) ? 90 : 0
    },
    theme(v){
      this.formColor.customHeader.theme = (v == false) ? 'dark': 'light'
    }
  },

  methods: {
    load() {

      let timestamp = (new Date().getTime() / 1000 | 0).toString(16);
      this.objectId = timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
        return (Math.random() * 16 | 0).toString(16);
      }).toLowerCase();

      const form = this.snap
      if (form.hasOwnProperty('headerColor'))
        this.formColor.headerColor = form.headerColor
      if (form.hasOwnProperty('headerPy'))
        this.formColor.headerPy = form.headerPy
      else
        this.formColor.headerColor = '#ffffff';
      if (form.hasOwnProperty('headerTheme'))
        this.formColor.headerTheme = form.headerTheme
      else
        this.formColor.headerTheme = false
      if (form.hasOwnProperty('homeBackground'))
        this.formColor.homeBackground = form.homeBackground
      else
        this.formColor.homeBackground = ''

      if (form.hasOwnProperty('primaryColor'))
        this.formColor.primaryColor = form.primaryColor


      if (form.hasOwnProperty('primaryColor'))
        this.formColor.primaryColor = form.primaryColor
      if (form.hasOwnProperty('secondaryColor'))
        this.formColor.secondaryColor = form.secondaryColor
      if (form.hasOwnProperty('titleColor'))
        this.formColor.titleColor = form.titleColor
      if (form.hasOwnProperty('primaryThemeDark'))
        this.formColor.primaryThemeDark = form.primaryThemeDark
      if (form.hasOwnProperty('primaryIconDark'))
        this.formColor.primaryIconDark = form.primaryIconDark
      if (form.hasOwnProperty('fontFamily')){
        this.formColor.fontFamily =  form.fontFamily
      }
      if (form.hasOwnProperty('customHeader')){
        this.formColor.customHeader = form.customHeader
        if(form.customHeader.deg == 0){
          this.deg = 1
        }
        if(form.customHeader.deg == 90){
          this.deg = 0
        }
      
      }

    
    },
    sendColors() {
      this.$emit('update-store', this.formColor)
    }
  },
};
</script>
